import BemIt, { addClass } from "@gtechdoodler/bem-it";

import {
	StyledButton,
	StyledDot,
	StyledDotsContainer,
} from "./PaginationDots.styles";
import { PaginationDotsProps } from "./PaginationDots.types";

const PaginationDots = ({
	numberOfDots,
	activeIndex = 0,
	onPageChange,
	className,
	...props
}: PaginationDotsProps) => {
	const block = new BemIt("PaginationDots");
	const dots = Array.from(Array(numberOfDots).keys());

	return (
		<StyledDotsContainer
			className={addClass(className).after(block)}
			{...props}
		>
			{dots.map((dot) => {
				const isActive = dot === activeIndex;
				const dotClass = block.el("dot").mod({ active: isActive }).out;
				const buttonClass = block.el("button").out;

				const onDotClick = () => {
					onPageChange(dot);
				};

				return (
					<StyledDot key={dot} className={dotClass}>
						<StyledButton className={buttonClass} onClick={onDotClick} />
					</StyledDot>
				);
			})}
		</StyledDotsContainer>
	);
};

export default PaginationDots;
